<template>
  <footer>
    <div
      class="footer-top"
      style="display: flex; justify-content: space-between"
    >
      <ul>
        <li class="first-item">
          <a href="#" @click="goDetails('policy', 35)">政策法规</a>
        </li>
        <li><a href="#" @click="goDetails('policy', 35)">上级精神</a></li>
        <li><a href="#" @click="goDetails('policy', 36)">规章制度</a></li>
        <li><a href="#" @click="goDetails('policy', 37)">相关文件</a></li>
      </ul>
      <ul>
        <li class="first-item">
          <a href="#" @click="goDetails('newBox', 33)">新闻动态</a>
        </li>
        <li><a href="#" @click="goDetails('newBox', 33)">行业资讯</a></li>
        <li><a href="#" @click="goDetails('newBox', 32)">协会资讯</a></li>
        <li><a href="#" @click="goDetails('newBox', 34)">招标信息</a></li>
        <!-- <li><a href="#" @click="goDetails(9)">考试公告</a></li> -->
      </ul>
      <ul>
        <li class="first-item">
          <a href="#" @click="goDetails('About', 7)">关于协会</a>
        </li>
        <li><a href="#" @click="goDetails('About', 7)">协会介绍</a></li>
        <li><a href="#" @click="goDetails('About', 40)">协会章程</a></li>
      </ul>
      <ul>
        <li class="first-item"><a href="#">快捷入口</a></li>
        <li><a @click="goDetails('Home', 33)">官网首页</a></li>
        <li><a href="#" @click="goDetails(14)">会员单位</a></li>
      </ul>
      <ul>
        <li class="first-item"><a>联系我们</a></li>
        <li>协会邮箱：szshgxh@126.com</li>
        <li>联系电话：0512 - 65523286</li>
        <li>协会地址：苏州市姑苏区阊胥路575号远东大厦301室</li>
        <div style="display: flex; justify-content: center">
          <div>
            <img
              class="imagetran"
              src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/74e9dd714e3046c8b971088a40eec00c.jpg"
              alt="护工协会公众号"
            />
            <p class="p3">护工协会公众号</p>
          </div>
          <div>
            <img
              class="imagetran"
              src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/6f3c21af59ea47aabdcca16720fe3a07.png"
              alt="协会客服微信号"
            />
            <p class="p3">协会客服微信号</p>
          </div>
          <div>
            <img
              class="imagetran"
              src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/f992e725ebed453cace2d9f31eb514e8.jpg"
              alt="护工协会小程序"
            />
            <p class="p3">护工协会小程序</p>
          </div>
        </div>
      </ul>
    </div>
    <p class="p4">苏州护工协会 Copyright © 2019 版权所有 苏ICP备19032408号-1</p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      tabindex: "",
    };
  },
  methods: {
    goDetails(path, type) {
      this.$router.push({
        name: path,
        query: {
          type: type,
        },
      });
    },
  },
  created() {
    //这边接收上个组件传递过来的arry数组，赋值给data中定义的workTask
    console.log(this.$route.query.tabindex);
    // this.workTask = this.$route.query.arry;
    this.tabindex = this.$route.query.tabindex;
  },
};
</script>

<style scoped>
/* 重置样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 20px;
}

body {
  font-family: Arial, sans-serif;
}

.footer-top {
  padding: 0 18em;
}

footer {
  background-color: #121212;
  color: white;
  padding: 2.666em 0;
  text-align: left;
}

footer ul {
  list-style-type: none;
  margin-bottom: 20px;
}

footer ul li {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 100%;
  letter-spacing: 0%;
  color: #98ceff;
  margin-bottom: 1.7998em;
}

.first-item {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.9em;
  line-height: 100%;
  letter-spacing: 0%;
  color: #ffffff;
  margin-bottom: 1.5996em;
}

footer ul li a {
  text-decoration: none;
}

footer ul li a:hover {
  text-decoration: underline;
}

footer div {
  margin-bottom: 10px;
}

footer img {
  width: 5.4em;
  height: 5.4em;
  margin-right: 10px;
}

.p3 {
  margin-top: 0.065em;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.7em;
  line-height: 100%;
  letter-spacing: 0%;
  color: #748ea6;
}

.p4 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.6em;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  color: #748ea6;
  text-align: center;
}

@media screen and (max-width: 1680px) {
  html {
    font-size: 16px;
  }
  .footer-top {
    padding: 0 10em;
  }

  .imageBox{
    padding: 12em 10em 12em 10em;
  }
  .new_main_box{
    padding: 3em 10em;
  }

}

@media screen and (max-width: 1280px) {
  html {
    font-size: 14px;
  }
  .footer-top {
    padding: 0 10em;
  }

  .imageBox{
    padding: 12em 10em 12em 10em;
  }
  .new_main_box{
    padding: 3em 10em;
  }
}

@media screen and (max-width: 960px) {
  html {
    font-size: 12px;
  }
  .footer-top {
    flex-direction: column;
    padding: 0 2em;
  }
}

@media screen and (max-width: 840px) {
  .footer-top {
    flex-direction: column;
    padding: 0 2em;
  }
}
</style>
